import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import toast from 'react-hot-toast';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  //const handleSubmit = (e) => {
  //  e.preventDefault();
  //  toast.success('Message sent successfully!');
  //  setFormData({ name: '', email: '', message: '' });
    //};

    const handleSubmit = (e) => {
        e.preventDefault();
        toast.error(
            "Something went wrong. You can use the contact details provided on the website to reach our team.",
            {
                icon: '⚠️',
                duration: 7000,
            }
        );
    };


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: "Email",
      content: "contact@platypusbox.com"
    },
    {
      icon: <FaPhone />,
      title: "Phone",
      content: "+91-9646951315, +91-8882256992"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Location",
      content: "New Delhi, India"
    }
  ];

  return (
    <section id="contact" className="relative min-h-screen bg-forest overflow-hidden">
      {/* Diagonal split overlay */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-forest" />
        <div 
          className="absolute inset-0 bg-[#3D2314] transform -skew-y-6 origin-top-right"
          style={{ top: '40%' }}
        />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-20">
        <motion.h2
          className="text-6xl font-bold text-center mb-20 text-accent-green"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Contact Us
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-forest/30 backdrop-blur-sm p-8 rounded-lg border border-accent-green/20"
          >
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-cream mb-2">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-forest/30 border border-accent-green/20 text-cream placeholder-cream/50 focus:outline-none focus:border-accent-green"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-cream mb-2">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-forest/30 border border-accent-green/20 text-cream placeholder-cream/50 focus:outline-none focus:border-accent-green"
                  placeholder="Your email"
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-cream mb-2">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  className="w-full px-4 py-2 rounded-lg bg-forest/30 border border-accent-green/20 text-cream placeholder-cream/50 focus:outline-none focus:border-accent-green resize-none"
                  placeholder="Your message"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full px-8 py-3 bg-accent-green text-forest font-semibold rounded-lg hover:bg-accent-green/90 transition-colors"
              >
                Send Message
              </button>
            </form>
          </motion.div>

          {/* Contact Info */}
          <div className="space-y-8">
            {contactInfo.map((info, index) => (
              <motion.div
                key={info.title}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-forest/30 backdrop-blur-sm p-6 rounded-lg border border-accent-green/20 flex items-center gap-4 group hover:border-accent-green/50 transition-all"
              >
                <div className="text-3xl text-accent-green group-hover:scale-110 transition-transform">
                  {info.icon}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-cream">
                    {info.title}
                  </h3>
                  <p className="text-cream/80">
                    {info.content}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
